import {
  SETUP_SIGNALR,
  LOGOUT,
  CHANGE_CAMPAIGN,
  GET_CONVERSATIONS,
} from '../../actionTypes';
import { toast } from 'react-toastify';
import { HttpTransportType } from '@microsoft/signalr';
import {
  incrementOfflineMessages,
  incrementTotalChat,
  addTranscriptIntoGrid,
  UpdateAgentInfoToTranscript,
  addOnlineOfflineAgentIntoGrid,
  setOnlineStatus,
  UpdateRatingOnTranscript,
  setDashboardHasRated,
  UpdateTranscriptMessageCount,
  setAgents,
  removeAgent,
} from '../../../features/dashboard/dashboardSlice';
import { setOnlineOfflineStatus } from '../../../features/users/team-activity/teamActivitySlice';
import {
  setHasRated,
  UpdateTranscriptMessages,
  updateConversationCompleteState,
} from '../../../features/transcripts/transcriptsSlice';
import {
  setConnectionStatus,
  setUserAccountError,
  setUserSubscription,
} from '../../../features/auth/authSlice';
import { getItem } from '../libs/localstorage';
import { setupChatUser } from '../../../features/chat/chatAPI';
import {
  setClosedBy,
  setDispositionShortCuts,
  setError,
  setHasRated as sRated,
  updateMessageDelivered,
  updateRequestMessage,
} from '../../../features/chat/chatSlice';

import {
  addRequestMessage,
  removeRequestMessage,
  setRatingValue,
} from '../../../features/chat/chatSlice';
import {
  getError,
  printConsoleLog,
  playAudio,
  getLanguageWord,
} from '../libs/helper';
import { fetchOnlineAgents } from '../../../features/dashboard/dashboardAPI';
import { insertActivity } from '../../../features/chat/chatAction';
import { ChatStatusMapping } from '../constants/values';
import { logoutUser } from '../../../features/auth/authAPI';
import { AGENT_STATUS } from '../../../app/common/constants/values';
import { throttle, update } from 'lodash';
const signalR = require('@microsoft/signalr');
let connectionR = undefined;
let interval = null;
let role = 'Supervisor';
const startSignalRConnection = (connectionR, dispatch, getState) => {
  connectionR
    .start()
    .then(function () {
      console.log('ChatHub has started::', connectionR.connectionId);
      dispatch(setConnectionStatus(signalR.HubConnectionState.Connected));
      const state = getState().dashboard;
      const userState = getState().auth.user;
      connectionR
        .invoke(
          'ChangeCampaignAsync',
          userState.Id,
          state.selectedCampaign.value
        )
        .catch((err) => {
          console.log(err);
        });

      clearInterval(interval);
    })
    .catch((error) => {
      console.log('ChatHub has error', error);
      dispatch(setConnectionStatus(signalR.HubConnectionState.Disconnected));
    });
  connectionR.onreconnecting(() => {
    dispatch(setConnectionStatus(signalR.HubConnectionState.Reconnecting));
  });
  connectionR.onreconnected((connectionId) => {
    console.log(`Chat SignalR : onreconnected :: connectionid ${connectionId}`);
    dispatch(setConnectionStatus(signalR.HubConnectionState.Connected));

    const state = getState().dashboard;
    const userState = getState().auth.user;
    connectionR
      .invoke('ChangeCampaignAsync', userState.Id, state.selectedCampaign.value)
      .catch((err) => {
        console.log(err);
      });
  });
  connectionR.onclose((error) => {
    console.log('Chat SignalR : disconnected... ', connectionR.connectionId);
    dispatch(setConnectionStatus(signalR.HubConnectionState.Disconnected));
    interval = setInterval(function () {
      console.log('Chat SignalR is disconnected , checking status manually');
      if (getItem('user') && getItem('token')) {
        if (connectionR.state == signalR.HubConnectionState.Disconnected) {
          connectionR
            .start()
            .then(function () {
              console.log('ChatHub restarted again');
              dispatch(
                setConnectionStatus(signalR.HubConnectionState.Connected)
              );
              const state = getState().dashboard;
              const userState = getState().auth.user;
              connectionR
                .invoke(
                  'ChangeCampaignAsync',
                  userState.Id,
                  state.selectedCampaign.value
                )
                .catch((err) => {
                  console.log(err);
                });

              clearInterval(interval);
            })
            .catch((error) => {
              console.log('ChatHub has error', error);
              dispatch(
                setConnectionStatus(signalR.HubConnectionState.Disconnected)
              );
            });
        }
      } else {
        clearInterval(interval);
      }
    }, 3000); // Restart connectionR after 3 seconds.
  });
};
const signalRMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    switch (action.type) {
      case SETUP_SIGNALR:
        // register signalR after the user logged in
        const accountId = '6241e46b2f5abe82aba78709';
        const user = getState().auth.user;
        let signalRURL = `${process.env.REACT_APP_CONNECTURL}/chathub?Email=${user.Email}&`;
        role = user.Role;
        switch (user.Role) {
          case 'Agent':
            signalRURL = `${signalRURL}Role=Agent&UserId=${
              user.Id
            }&AccountId=0&CampaignId=${user.Campaigns.map((x) => x.id).join(
              ','
            )}&CampaignName=${user.Campaigns.map((x) => x.name).join(',')}`;
            dispatch({
              type: GET_CONVERSATIONS,
              payload: {
                pageNo: 1,
                searchValue: '',
                firstLoad: true,
                channelType: 4,
                campaignIds: user.Campaigns.map((x) => x.id),
              },
            });
            dispatch(fetchOnlineAgents(user.Campaigns.map((x) => x.id)));
            break;
          case 'Supervisor':
            const dashboardState = getState().dashboard;
            signalRURL = `${signalRURL}Role=Supervisor&UserId=${user.Id}&AccountId=${user.accountId}&CampaignId=${dashboardState.selectedCampaign.value}&CampaignName=${dashboardState.selectedCampaign.label}`;
            break;
        }
        connectionR = new signalR.HubConnectionBuilder()
          .withUrl(signalRURL, {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .build();

        // register handlers

        connectionR.on('incomingChatNotification', function (data) {
          console.log('Inside incomingChatNotification', data);
          data = JSON.parse(data);
          if (role == 'Agent') {
            const requests = getState().chat.requests;
            const userState = getState().auth.user;
            const languageKeys = userState.languageKeys;
            const index = requests.findIndex(
              (x) => x.CustomerConversationSid == data.CustomerConversationSid
            );
            if (index == -1) {
              data.CustomerType = 0;
              dispatch(addRequestMessage(data));
            } else {
              dispatch(
                updateRequestMessage({
                  index,
                  message: data.MessageText,
                  messageTime: data.MessageDateTime,
                })
              );
            }
            playAudio();
            toast.success(
              <div>
                {getLanguageWord(
                  languageKeys.value?.New_Visitor,
                  'New visitor from'
                )}{' '}
                <span style={{ overflowWrap: 'anywhere' }}>
                  {data.CustomerInfo?.SiteUrl || ''}
                </span>{' '}
                <br /> {data.FriendlyName}.
              </div>
            );
          }
          dispatch(addTranscriptIntoGrid(data));
          dispatch(incrementTotalChat());
        });

        connectionR.on('incomingChatAcceptedNotification', function (data) {
          console.log('Inside incomingChatAcceptedNotification', data);
          const userState = getState().auth.user;
          const languageKeys = userState.languageKeys;
          data = JSON.parse(data);
          if (role == 'Agent') {
            const requests = getState().chat.requests;
            const index = requests.findIndex(
              (x) => x.CustomerConversationSid == data.CustomerConversationSid
            );
            if (index > -1) {
              toast.info(
                `${data.FriendlyName} ${getLanguageWord(
                  languageKeys.value?.Accepted_By_Other_Agent,
                  'accepted by some other agent'
                )}`
              );
              dispatch(removeRequestMessage(index));
            }
          }
          dispatch(UpdateAgentInfoToTranscript(data));
        });

        connectionR.on('receiveMessageEvent', function (data) {
          console.log(`receiveMessageEvent => ${data}`);
          data = JSON.parse(data);
          dispatch(UpdateTranscriptMessages(data));
          dispatch(UpdateTranscriptMessageCount(data));
        });

        connectionR.on('handoverChat', function (data) {
          data = JSON.parse(data);
          dispatch(UpdateAgentInfoToTranscript(data));
        });

        connectionR.on('agentChatComplete', (data) => {
          data = JSON.parse(data);
          if (role != 'Agent') {
            dispatch(
              updateConversationCompleteState({
                conversationSid: data.CustomerConversationSid,
                closedBy: 2,
                dateClosed: new Date().toISOString(),
              })
            );
          }
          printConsoleLog('Inside customerChatEndNotification', data);
        });

        connectionR.on('customerChatEndNotification', (data) => {
          const userState = getState().auth.user;
          const languageKeys = userState.languageKeys;
          data = JSON.parse(data);
          if (role == 'Agent') {
            const items = getState().chat.conversations.items;
            const index = items.findIndex(
              (x) => x.sid == data.CustomerConversationSid
            );
            if (index > -1) {
              toast.success(
                `${items[index].nickName} ${getLanguageWord(
                  languageKeys.value?.Chat_Closed_By_Customer,
                  'chat has been 🔒 closed by customer'
                )}`
              );
              dispatch(
                setClosedBy({
                  index,
                  closedBy: 1,
                  dateClosed: new Date().toISOString(),
                  disposition: { name: '' },
                  hasDisposition: false,
                  note: { title: '', name: '' },
                })
              );
            }
          } else {
            dispatch(
              updateConversationCompleteState({
                conversationSid: data.CustomerConversationSid,
                closedBy: 1,
                dateClosed: new Date().toISOString(),
              })
            );
          }
          printConsoleLog('Inside customerChatEndNotification', data);
        });
        connectionR.on('ratingNotification', function (data) {
          const userState = getState().auth.user;
          const languageKeys = userState.languageKeys;
          data = JSON.parse(data);
          console.log('Inside ratingNotification', data);
          if (role == 'Agent') {
            const items = getState().chat.conversations.items;
            const index = items.findIndex((x) => x.sid == data.ConversationSid);
            if (index > -1) {
              toast.success(
                `${items[index].nickName}'s chat has been ⭐ rated.`
              );
              dispatch(sRated({ index, hasRated: true }));
            }
          } else {
            toast.success(`${data.Name}'s chat has been ⭐ rated.`);
          }
          dispatch(UpdateRatingOnTranscript(data));
          dispatch(setDashboardHasRated(data.ConversationSid));
          dispatch(setHasRated(data.ConversationSid));
        });
        connectionR.on('agentOnlineNotification', function (data) {
          data = JSON.parse(data);
          console.log('Inside agentOnlineNotification', data);
          if (role != 'Agent') toast.success(`${data.Email} is Online`);
          dispatch(
            setOnlineStatus({
              email: data.Email,
              value: true,
              agentStatus: data.NewActivity,
            })
          );
          dispatch(
            setOnlineOfflineStatus({
              email: data.Email,
              value: true,
              agentStatus: data.NewActivity,
            })
          );
          dispatch(
            addOnlineOfflineAgentIntoGrid({
              data: data,
              isOnline: true,
              agentStatus: data.NewActivity,
            })
          );
        });
        connectionR.on('agentOfflineNotification', function (data) {
          data = JSON.parse(data);
          console.log('Inside agentOfflineNotification', data);

          var status = AGENT_STATUS[data.NewActivity];
          var isOffline = status != 'Break' ? true : false;
          if (isOffline) {
            dispatch(
              addOnlineOfflineAgentIntoGrid({
                data: data,
                isOnline: false,
                agentStatus: data.NewActivity,
              })
            );
            if (role != 'Agent') toast.success(`${data.Email} is Offline`);
          }
          dispatch(
            setOnlineStatus({
              email: data.Email,
              value: !isOffline,
              agentStatus: data.NewActivity,
            })
          );
          dispatch(
            setOnlineOfflineStatus({
              email: data.Email,
              value: !isOffline,
              agentStatus: data.NewActivity,
            })
          );
        });
        connectionR.on('newChatNotification', function (data) {
          console.log('Inside newChatNotification', data);
          data = JSON.parse(data);
          if (role != 'Agent') toast.success('New incoming chat');
          //dispatch(incrementTotalChat());
        });
        connectionR.on('offlineMessageNotification', function (data) {
          console.log('Inside offlineMessageNotification', data);
          if (role != 'Agent')
            toast.success('A new offline message is received');
          dispatch(incrementOfflineMessages());
        });
        connectionR.on('offlineAgent', function (data) {
          data = JSON.parse(data);
          console.log('offlineAgent', data);
          var status = AGENT_STATUS[data.NewActivity];
          var isOffline = status != 'Break' ? true : false;
          const agents = getState().dashboard.agents.data;
          const index = agents.findIndex((x) => x.id == data.UserId);
          if (isOffline) {
            if (index > -1) {
              dispatch(removeAgent(index));
            }
            if (user.Id == data.UserId) {
              dispatch(logoutUser());
              return next(action);
            }
          } else {
            if (user.Id != data.UserId) {
              dispatch(fetchOnlineAgents(user.Campaigns.map((x) => x.id)));
              return next(action);
            }
          }
        });
        connectionR.on('onlineAgent', function (data) {
          data = JSON.parse(data);
          if (user.Id != data.UserId) {
            dispatch(fetchOnlineAgents(user.Campaigns.map((x) => x.id)));
            return next(action);
          }
          console.log('onlineAgent', data);
        });
        connectionR.on(
          'messageDelivered',
          throttle(function (data) {
            console.log('Inside messageDelivered', data);
            data = JSON.parse(data);
            const conv = getState().chat.conversations.items.find(
              (x) => x.id == data.ConversationId
            );
            if (conv) {
              dispatch(updateMessageDelivered(data));
            }
          }),
          1000
        );
        connectionR.on('accountError', function (data) {
          // console.log('Inside accountError => ', data);
          // console.log('Inside accountError user => ', user);
          data = JSON.parse(data);
          console.log('accountError event received', data);
          const { accountId, isCompleted, subscription, Message } = data;

          //campaign match for logout user
          if (accountId == user.accountId) {
            if (isCompleted) {
              dispatch(setUserAccountError(false));
              if (subscription) {
                dispatch(setUserSubscription(subscription));
              }
            }
            //if supervisor who created the account
            else if (user.Email == user.account.accountEmail) {
              dispatch(setUserAccountError(true));
              toast.error(Message);
            }
            //else logut everyone
            else {
              setTimeout(() => {
                dispatch(logoutUser());
              }, 3000);
            }
          }
        });
        connectionR.on('accountPaymentSuccess', function (data) {
          data = JSON.parse(data);
          console.log('accountPaymentSuccess event received', data);
          const { accountId, subscription } = data;
          if (accountId == user.accountId) {
            dispatch(setUserSubscription(subscription));
          }
        });

        if (connectionR.state !== signalR.HubConnectionState.Connected) {
          window.signalRConnection = connectionR;
          startSignalRConnection(connectionR, dispatch, getState);
        }
        break;
      case LOGOUT:
        if (
          connectionR &&
          connectionR.state == signalR.HubConnectionState.Connected
        ) {
          setTimeout(() => {
            connectionR.off('incomingChatNotification');
            connectionR.off('customerChatEndNotification');
            connectionR.off('ratingNotification');
            connectionR
              .stop()
              .then((r) => console.log('Chat signalr connectionR stopped'));
            connectionR = undefined;
            clearInterval(interval);
          }, 5000);
          connectionR.invoke(`OnLogout`).catch((err) => {
            console.log(err);
          });
        }
        break;
      case CHANGE_CAMPAIGN: {
        const state = getState().dashboard;
        const user = getState().auth.user;
        const campaign = user.Campaigns.find(
          (x) => x.id == state.selectedCampaign.value
        );
        dispatch(
          setDispositionShortCuts({
            userId: user.Id,
            dispositions: campaign.dispositions,
            chatShortKeys: campaign.chatShortKeys,
          })
        );
        connectionR
          .invoke('ChangeCampaignAsync', user.Id, state.selectedCampaign.value)
          .catch((err) => {
            console.log(err);
          });
        break;
      }
    }
    return next(action);
  };

export default signalRMiddleware;
